<script setup>
import { ref } from 'vue';
import videoItem from '../sliders/videoItem.vue'
import { getIsArabicLayoutDirection } from '@/utils/additional';

const props = defineProps({
   images: Array,
});
</script>

<template>
   <div :class="{ 'items-list': true, 'RTL-flex-direction': getIsArabicLayoutDirection() }">
      <div v-for="(item, index) in props.images" :key="index" class="items-element">

         <img class="item" :src="item" :alt="`Image ${index}`" v-if="typeof item === 'string'">

         <videoItem :item="item" v-if="typeof item === 'object' && item.type === 'video'" />

         <!-- <div class="item" v-if="typeof item === 'object'">
            <video class="item__impress" autoplay loop muted>
               <source :src="item.url" type="video/webm" />
            </video>
         </div> -->

      </div>
   </div>
</template>

<style scoped>
.items-list {
   display: flex;
   flex-direction: row;
   align-items: center;
   overflow: auto;
   /* overflow-y: scroll; */
   overflow-x: scroll;
   scrollbar-width: none;
   -ms-overflow-style: none;
   gap: 10px;
   margin-bottom: 20px;
   scroll-snap-type: x mandatory;
   padding: 3px 0px;
}

.items-list ::-webkit-scrollbar {
   display: none;
}

.items-element {
   flex-shrink: 0;
   scroll-snap-align: start;
   padding-left: 3px;
}

.item {
   height: var(--itetm_height);
   min-width: var(--itetm_min-width);
   max-height: var(--itetm_height);
   /* width: 100%; */
   /* min-width: 119px; */
   /* height: auto; */
   border-radius: var(--itetm_border-radius);
   box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.item__impress {
   height: var(--itetm_height);
   min-width: var(--itetm_min-width);

   border-radius: var(--itetm_border-radius);
}
</style>